import qs from 'query-string';
import { apiConfig } from '@/services/api-config';

export default async function (car: string) {
  const userLogged = JSON.parse(sessionStorage.getItem('userLogged') as string);
  const { stKey } = userLogged.company;

  const query = qs.stringify({ car, tokenKey: stKey });

  return apiConfig.get(`api/territory/check-if-car-exists?${query}`)
    .then((response) => response.data)
    .catch();
}
